export default __webpack_public_path__ + "static/media/6588cf424afe1e2d0ab1c9d19fd0da84.png";